import mb from './markdown-beautiful.vue'

export default mb
